module.exports = __webpack_public_path__ + "img/0.93783c88.jpg";